import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-22/task-01";

const task: Slide = {
  title: "Compared to a vented box system, a passive radiator system:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
